import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import GeneralLedgerTable from './table';
import ApiService from '@/services/api';
import dayjs from "dayjs";
import CashBookTable from './table';
import { exportCashBookToExcel } from '@/helpers/utils';


const CashBook = () => {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cooperative, setCooperative] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  });

  // Load orders on component mount
  useEffect(() => {
    loadData();
  }, []);

  const dummyData = [
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.17",
    anggota: "99099.002.0000.001",
    coa: "3.01.02",
    keterangan: "Simpanan wajib",
    debit: 50000,
    kredit: 0,
    saldo: 123583184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.17",
    anggota: "99099.002.0000.001",
    coa: "3.01.02",
    keterangan: "Simpanan wajib",
    debit: 0,
    kredit: 50000,
    saldo: 123533184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.18",
    anggota: "99099.002.0000.001",
    coa: "3.01.03",
    keterangan: "Simpanan Sukarela",
    debit: 100000,
    kredit: 0,
    saldo: 123633184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.19",
    anggota: "99099.002.0000.001",
    coa: "3.01.02",
    keterangan: "Simpanan wajib",
    debit: 50000,
    kredit: 0,
    saldo: 123683184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.19",
    anggota: "99099.002.0000.001",
    coa: "3.01.02",
    keterangan: "Simpanan wajib",
    debit: 0,
    kredit: 50000,
    saldo: 123633184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.20",
    anggota: "99099.002.0000.001",
    coa: "3.01.02",
    keterangan: "Simpanan wajib",
    debit: 50000,
    kredit: 0,
    saldo: 123683184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.21",
    anggota: "99999.001.0000.021",
    coa: "3.01.02",
    keterangan: "Simpanan wajib",
    debit: 100000,
    kredit: 0,
    saldo: 123783184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.22",
    anggota: "99999.001.0000.010",
    coa: "3.01.02",
    keterangan: "Simpanan wajib",
    debit: 8450000,
    kredit: 0,
    saldo: 132233184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.23",
    anggota: "99099.002.0000.001",
    coa: "1.01.04.01",
    keterangan: "Piutang Umum",
    debit: 41000,
    kredit: 0,
    saldo: 132274184,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.23",
    anggota: "99099.002.0000.001",
    coa: "4.01.01",
    keterangan: "Jasa Piutang Umum",
    debit: 2500,
    kredit: 0,
    saldo: 132276684,
  },
  {
    tanggal: "02/10/2025",
    slip: "25.10.999.23",
    anggota: "99099.002.0000.001",
    coa: "4.01.07",
    keterangan: "Administrasi Piutang",
    debit: 100000,
    kredit: 0,
    saldo: 132376684,
  },
  ];

  const [filters, setFilters] = useState({
    startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  });

  const exportExcel = async () => {
    exportCashBookToExcel(report, dayjs(filters.startDate).format('DD-MM-YYYY'),dayjs(filters.endDate).format('DD-MM-YYYY'))
  }

  const loadData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const profile = JSON.parse(localStorage.getItem('user_profile'));
      const cooperativeId = profile?.cooperative.id || 0;
      setCooperative(profile?.cooperative)
      const response = await ApiService.getCashBook(
        cooperativeId,
        filters.startDate,
        filters.endDate
      )
      if (response.status === 200) {
        setReport(response.data);
      }
    } catch (error) {
      setReport([]);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <nav className="flex mb-6" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-3">
          <li className="inline-flex items-center">
            <Link
              to="/dashboard"
              className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
            >
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
              </svg>
              Dashboard
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
              </svg>
              <button
                onClick={() => navigate('/admin/list-principal-savings')}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
              >
                Buku Kas Harian
              </button>
            </div>
          </li>
        </ol>
      </nav>
    
      <div className="flex flex-auto flex-col">
        <div className="card">
          <div className="card-header">
            <div className="flex justify-between items-center">
              <h4 className="card-title">Buku Kas Harian</h4>
              <div className="flex gap-2">
                <input
                  type="date"
                  value={filters.startDate}
                  onChange={(e) =>
                    setFilters({ ...filters, startDate: e.target.value })
                  }
                  className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm"
                />
                <input
                  type="date"
                  value={filters.endDate}
                  onChange={(e) =>
                    setFilters({ ...filters, endDate: e.target.value })
                  }
                  className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm"
                />
                <button
                  className="btn bg-blue-600 text-white px-4 py-2 rounded"
                  onClick={() => loadData(1)}
                  disabled={loading}
                >
                  <i className="mgc_search_line me-2"></i>Filter
                </button>
                <button
                  className="btn bg-green-600 text-white px-4 py-2 rounded"
                  onClick={() => exportExcel()}
                  disabled={loading}
                >
                  <i className="mgc_download_2_line me-2"></i>Export
                </button>
                <button
                  className="btn btn-sm bg-secondary text-white"
                  onClick={() => loadData(1)}
                  disabled={loading}
                >
                  <i className="mgc_refresh_1_line me-2"></i>Refresh
                </button>
              </div>
            </div>
          </div>

          {cooperative && (
            <div className="text-center my-6 print:block">
              <h2 className="text-xl font-bold">{cooperative.name}</h2>
              <div className="mt-4">
                <h3 className="text-lg font-bold">Buku Kas Harian</h3>
                <p className="text-sm">{dayjs(filters.startDate).format('DD MMMM YYYY')} - {dayjs(filters.endDate).format('DD MMMM YYYY')}</p>
              </div>
            </div>
          )}
          
          <div className="p-6">
            <CashBookTable data={report} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CashBook;